<template>
  <a href="/favorites" class="favorite-counter">
    <span class="favorite-counter__count" v-if="count>0">{{count}}</span>
    <span class="favorite-counter__count favorite-counter__count--0" v-if="count === 0">0</span>
    <svg viewBox="0 0 25 25" class="favorite-counter__icon">
      <use xlink:href="/assets/site/images/sprites.svg?ver=33#sprite-heart"></use>
    </svg>
  </a>

</template>
<script>
    import { bus } from './bus.js'
    export default {
        data() {
            return {
                count:0,
            }
        },
        mounted() {
            this.getCount();
            bus.$on('add-favorite', this.favoriteEventHandler)
        },
        methods: {
            favoriteEventHandler(status) {
                if (status) {
                    this.count++
                } else {
                    if (this.count > 0) {
                        this.count--;
                    }
                }
            },
            getCount() {
                axios.get('/api/favorite/count')
                    .then((response) => {
                        this.count = response.data;
                    })
            }
        }
    }
</script>